/**
 * @generated SignedSource<<1a841d13b86625f22822a201d5cebfc1>>
 * @relayHash 87ec3e6609986868281595699cb06121
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 67c31be0b5c3bcf10d45efc5f774a6e06164c8391e4b560ab1645023d34756e5

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useLegacyAgentSessionsDataPaginationQuery$variables = {
  after?: string | null;
  aqlQuery: string;
  pageSize?: number | null;
  sharingContext: string;
  shouldReadSessions: boolean;
  sort?: string | null;
};
export type useLegacyAgentSessionsDataPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useLegacyAgentSessionsData_query">;
};
export type useLegacyAgentSessionsDataPaginationQuery = {
  response: useLegacyAgentSessionsDataPaginationQuery$data;
  variables: useLegacyAgentSessionsDataPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aqlQuery"
  },
  {
    "defaultValue": 25,
    "kind": "LocalArgument",
    "name": "pageSize"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sharingContext"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldReadSessions"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sort"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "aqlQuery",
  "variableName": "aqlQuery"
},
v3 = {
  "kind": "Variable",
  "name": "sort",
  "variableName": "sort"
},
v4 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "pageSize"
  },
  {
    "kind": "Variable",
    "name": "shardingContext",
    "variableName": "sharingContext"
  },
  (v3/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "ScalarField",
  "name": "accountId"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useLegacyAgentSessionsDataPaginationQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "pageSize",
            "variableName": "pageSize"
          },
          {
            "kind": "Variable",
            "name": "sharingContext",
            "variableName": "sharingContext"
          },
          {
            "kind": "Variable",
            "name": "shouldReadSessions",
            "variableName": "shouldReadSessions"
          },
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "useLegacyAgentSessionsData_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useLegacyAgentSessionsDataPaginationQuery",
    "selections": [
      {
        "condition": "shouldReadSessions",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "AgentSessionConnection",
            "kind": "LinkedField",
            "name": "agent_sessionQuery",
            "plural": false,
            "selections": [
              {
                "concreteType": "AgentSessionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "AgentSession",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "state"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "stateReason"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "expireTime"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "lastStateChangeAt"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isRovo"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "agentAccountId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "convoAiAgentId"
                      },
                      {
                        "alias": "conversationChannel",
                        "concreteType": "AgentConversationChannel",
                        "kind": "LinkedField",
                        "name": "nativeConversationChannel",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "createdAt"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "interactionChannel"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "interactionChannelAri"
                          },
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "lastMessage"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "lastMessageTimestamp"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "lastMessageType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "lastAgentMessageId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "lastAgentMessageStatus"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "readStatus"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isPlanning"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isPinned"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "pinnedAt"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "status"
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "agent",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "picture"
                          },
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v6/*: any*/),
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "studioAgent",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v6/*: any*/),
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "associatedEntities",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "key"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "webUrl"
                              }
                            ],
                            "type": "JiraIssue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "title"
                              },
                              {
                                "concreteType": "ConfluencePageLinks",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "base"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "webUi"
                                  }
                                ]
                              }
                            ],
                            "type": "ConfluencePage"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ]
                      },
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  }
                ]
              }
            ]
          },
          {
            "args": (v4/*: any*/),
            "filters": [
              "shardingContext",
              "aqlQuery",
              "sort"
            ],
            "handle": "connection",
            "key": "useAgentSessionsSnapshot_agent_sessionQuery",
            "kind": "LinkedHandle",
            "name": "agent_sessionQuery"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "67c31be0b5c3bcf10d45efc5f774a6e06164c8391e4b560ab1645023d34756e5",
    "metadata": {},
    "name": "useLegacyAgentSessionsDataPaginationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6655a61e00c2c37256941ad478dc75a0";

export default node;
